// Canonical identity-authority public identifier, as accepted by
// getProfilePresentation. It is the only valid `UserProfile` route parameter:
// a Firebase UID must never be used to link to a profile.
export const PROFILE_PUBLIC_IDENTIFIER_PATTERN = /^[a-z0-9][a-z0-9_-]{2,63}$/;

export const canonicalProfilePublicIdentifier = (value) =>
  typeof value === "string" && PROFILE_PUBLIC_IDENTIFIER_PATTERN.test(value)
    ? value
    : null;

// Every link to a person's profile is built here, so no caller can pass a
// UID-shaped value it happened to have at hand.
export const userProfileRoute = (value) => {
  const publicIdentifier = canonicalProfilePublicIdentifier(value);
  return publicIdentifier
    ? { name: "UserProfile", params: { userUID: publicIdentifier } }
    : null;
};

// Reads what a person pastes to name someone: a profile link or the bare
// public identifier. Anything else, including a UID-shaped value, is null.
export const profilePublicIdentifierFromReference = (value) => {
  if (typeof value !== "string") return null;
  const text = value.trim();
  const linked = /\/userprofile\/([^/?#\s]+)\/?(?:[?#]\S*)?$/.exec(text);
  return canonicalProfilePublicIdentifier(linked ? linked[1] : text);
};

// The author of a feed item: the signed-in viewer's own identifier for their
// own items, otherwise the owner identifier supplied with the item. `owner`
// itself is a legacy UID and is only compared, never linked.
export const itemAuthorProfileIdentifier = ({
  item,
  isOwner = false,
  currentUserUid = null,
  ownPublicIdentifier = null,
} = {}) => {
  const itemOwnerIdentifier = canonicalProfilePublicIdentifier(
    item?.ownerPublicIdentifier
  );
  if (!isOwner) return itemOwnerIdentifier;
  return (
    canonicalProfilePublicIdentifier(ownPublicIdentifier) ||
    (typeof currentUserUid === "string" &&
    currentUserUid.length > 0 &&
    item?.owner === currentUserUid
      ? itemOwnerIdentifier
      : null)
  );
};
